import axiosInstance from "auth/FetchInterceptor";
import { SETTING_MAPS_API, GET_ALL_SETTING_MAPS } from "constants/ApiConstant";
const SettingMapsService = {};

SettingMapsService.getAllMapsApi = function (data) {
  return axiosInstance.get(GET_ALL_SETTING_MAPS, data);
};

SettingMapsService.setActiveMapApi = function (data) {
  return axiosInstance.put(SETTING_MAPS_API, data);
};

export default SettingMapsService;
